module.exports = __webpack_public_path__ + "img/22.031eca3d.png";